module.exports = __webpack_public_path__ + "static/media/buffet7.e7a0cb19.jpg";